module.exports = __webpack_public_path__ + "img/self-schedule-icon.5bdac421.svg";